import React from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import 'es6-promise/auto';

import ResponsiveBGImage from '../../Util/ResponsiveBGImage/ResponsiveBGImage';

// import assets
import './videoModule.scss';
import '../../../../assets/icons/Lenspire_Icon_VideoPlay.svg';

class VideoModuleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      videoMode: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.setState({
      videoMode: true,
    });
  }

  render() {
    const options = {
      url: this.props.url,
      width: '100%',
      height: '100%',
      playing: true,
      controls: true,
    };

    return (
      <div className="m-article-module">
        <div className="m-video-module">
          <div className="m-video-module__ratio-wrapper">
            {this.state.videoMode ? (
              <div className="m-video-module__video">
                <ReactPlayer {...options} />
              </div>
            ) : (
              <div onClick={this.handleClick} role={'button'} tabIndex={-1}>
                <ResponsiveBGImage
                  className="m-video-module__image"
                  src={{
                    sm: this.props.src['750'],
                    md: this.props.src['1020'],
                    lg: this.props.src['1600'],
                    xl: this.props.src['1280'],
                    xxl: this.props.src['1600'],
                    xxxl: this.props.src['2560'],
                    default: this.props.src.default,
                  }}
                  alt={this.props.alt}
                  disableZoom
                >
                  <div className="m-video-module__icon">
                    <svg>
                      <use xlinkHref="#Lenspire_Icon_VideoPlay" />
                    </svg>
                  </div>
                </ResponsiveBGImage>
              </div>
            )}
          </div>
          <div className="m-video-module__description" dangerouslySetInnerHTML={{ __html: this.props.description }} />
        </div>
      </div>
    );
  }
}

VideoModuleView.propTypes = {
  url: PropTypes.string,
  src: PropTypes.shape(),
  alt: PropTypes.string,
  description: PropTypes.string,
};

VideoModuleView.defaultProps = {
  url: '',
  alt: '',
  src: {},
  description: '',
};

export default VideoModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/VideoModule/VideoModuleView.jsx